import { store } from "../../../index"; // of juiste pad
import bedrijvenData from "./bedrijven.json"; // dit is jouw JSON

export default function bedrijven(type) {
  const user = store.getState().auth.user;
  const soort = user?.bedrijf?.soort;

  // Als het type niet bestaat in de JSON, geef dan gewoon 'Onbekend' terug
  const typeData = bedrijvenData[type];
  if (!typeData) return "Onbekend";

  // Zoek de specifieke waarde op basis van bedrijfstype
  const waarde = typeData[soort];

  // Als die bestaat, geef hem terug — anders een fallback
  return waarde || typeData["default"] || type; // default of gewoon het type zelf
}